/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone";
moment.locale('ja')
let FilterObject = 'FilterObject'

export interface HomeState {
  displayAll: boolean
  tags: string[]
  selectedTags: string[]
  unselectedTags: string[]
  selectedTagKeys: string[]
  displayOnlyActive: boolean
  displaySortByActiveTime: boolean
  displayGrouping: boolean
  loginSound: boolean
  logoffSound: boolean
  commentSound: boolean
  reactionSound: boolean
  pictureSound: boolean
  weeklySound: boolean
  approvalSound: boolean
  errorSound: boolean
  onlyDisplayingUsers: boolean
  isPrivacyMode: boolean
  volume: number
  [key: string]: any;
}

const Home = defineModule({
  state: (): HomeState => {
    var baseObj: HomeState = {
      displayAll: true,
      tags: [],
      selectedTags: [],
      unselectedTags: [],
      selectedTagKeys: [],
      displayOnlyActive: false,
      displaySortByActiveTime: false,
      displayGrouping: false,
      loginSound: true,
      logoffSound: true,
      commentSound: true,
      reactionSound: true,
      pictureSound: true,
      weeklySound: true,
      approvalSound: false,
      errorSound: false,
      onlyDisplayingUsers: false,
      isPrivacyMode: false,
      volume: 50
    }
    var obj = Lib.Session.value(FilterObject)
    if (obj != null) {
      baseObj.displayAll = obj.displayAll
      baseObj.selectedTagKeys = obj.selectedTagKeys == null ? [] : obj.selectedTagKeys
      baseObj.displayOnlyActive = obj.displayOnlyActive
      baseObj.displaySortByActiveTime = obj.displaySortByActiveTime
      baseObj.displayGrouping = obj.displayGrouping
      baseObj.loginSound = obj.loginSound
      baseObj.logoffSound = obj.logoffSound
      baseObj.commentSound = obj.commentSound
      baseObj.reactionSound = obj.reactionSound
      baseObj.pictureSound = obj.pictureSound
      baseObj.weeklySound = obj.weeklySound
      baseObj.approvalSound = obj.approvalSound
      baseObj.errorSound = obj.errorSound
      baseObj.onlyDisplayingUsers = obj.onlyDisplayingUsers
      baseObj.isPrivacyMode = obj.isPrivacyMode
      baseObj.volume = obj.volume
    }
    return baseObj
  },
  getters: {
    activeUserGroups(...args): Array<any> {
      const { state, rootState } = loginGetterContext(args)
      var toDisplay = state.displayOnlyActive ? rootState.Users.activeUsers.filter(element => element.status == 'active') : rootState.Users.activeUsers
      var sorted = state.displaySortByActiveTime ? toDisplay.sort((b, a) => {
        if (a.startedGMT != null && b.startedGMT == null) return 1
        if (a.startedGMT == null && b.startedGMT != null) return -1
        if (a.startedGMT != null && b.startedGMT != null) {
          var astarted = moment.tz(a.startedGMT, 'Etc/GMT')
          var bstarted = moment.tz(b.startedGMT, 'Etc/GMT')
          if (astarted > bstarted) return 1
          if (bstarted > astarted) return -1
        }
        if (a.startedGMT == null && b.startedGMT == null) {
          if (a.endedGMT != null && b.endedGMT == null) return 1
          if (a.endedGMT == null && b.endedGMT != null) return -1
          if (a.endedGMT != null && b.endedGMT != null) {
            var aended = moment.tz(a.endedGMT, 'Etc/GMT')
            var bended = moment.tz(b.endedGMT, 'Etc/GMT')
            if (aended > bended) return 1
            if (bended > aended) return -1
          }
        }
        return 0        
      }) : toDisplay
      if (state.displayAll) return [{name: null, users: sorted}]
      if (!state.displayGrouping) {
        var groupFiltered = sorted.filter((element: any) => {
          return state.selectedTags.reduce((prevflag: boolean, tag: any) => {
            return prevflag || tag.assignedUsers.reduce((prevau: boolean, au: any) => {
              return prevau || au == element.displayName
            }, false)
          }, false)
        })
        return [{name: null, users: groupFiltered}]
      }
      return state.selectedTags.map((element: any) => {
        return {name: element.name, users: sorted.filter(user => {
          return element.assignedUsers.reduce((prevau: boolean, au: any) => {
            return prevau || au == user.displayName
          }, false)
        })}
      })
    },
    activeUsers(...args): Array<any> {
      const { state, rootState } = loginGetterContext(args)
      var toDisplay = state.displayOnlyActive ? rootState.Users.activeUsers.filter(element => element.status == 'active') : rootState.Users.activeUsers
      var sorted = state.displaySortByActiveTime ? toDisplay.sort((b, a) => {
        if (a.startedGMT != null && b.startedGMT == null) return 1
        if (a.startedGMT == null && b.startedGMT != null) return -1
        if (a.startedGMT != null && b.startedGMT != null) {
          var astarted = moment.tz(a.startedGMT, 'Etc/GMT')
          var bstarted = moment.tz(b.startedGMT, 'Etc/GMT')
          if (astarted > bstarted) return 1
          if (bstarted > astarted) return -1
        }
        if (a.startedGMT == null && b.startedGMT == null) {
          if (a.endedGMT != null && b.endedGMT == null) return 1
          if (a.endedGMT == null && b.endedGMT != null) return -1
          if (a.endedGMT != null && b.endedGMT != null) {
            var aended = moment.tz(a.endedGMT, 'Etc/GMT')
            var bended = moment.tz(b.endedGMT, 'Etc/GMT')
            if (aended > bended) return 1
            if (bended > aended) return -1
          }
        }
        return 0        
      }) : toDisplay
      if (state.displayAll) return sorted
      var groupFiltered = sorted.filter((element: any) => {
        return state.selectedTags.reduce((prevflag: boolean, tag: any) => {
          return prevflag || tag.assignedUsers.reduce((prevau: boolean, au: any) => {
            return prevau || au == element.displayName
          }, false)
        }, false)
      })
      return groupFiltered
    }
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
      if (param.name == 'tags') {
        state.selectedTags = state.selectedTagKeys.reduce((prev: Array<any>, current: any) => {
          param.value.forEach((element: any) => {
            if (element.memberTagId == current) {prev.push(element)}
          })
          return prev
        }, [])
        state.unselectedTags = state.tags.filter((element: any) => {
          return !state.selectedTags.reduce((prev: boolean, current: any) => (prev || current.memberTagId == element.memberTagId), false)
        })
      }
      if (param.name == 'selectedTags') {
        state.selectedTagKeys = state.selectedTags.map((element: any) => element.memberTagId)
      }
      Lib.Session.valueSet(FilterObject, {
        displayAll: state.displayAll,
        selectedTagKeys: state.selectedTagKeys,
        displayOnlyActive: state.displayOnlyActive,
        displaySortByActiveTime: state.displaySortByActiveTime,
        displayGrouping: state.displayGrouping,
        loginSound: state.loginSound,
        logoffSound: state.logoffSound,
        commentSound: state.commentSound,
        reactionSound: state.reactionSound,
        onlyDisplayingUsers: state.onlyDisplayingUsers,
        volume: state.volume,
        pictureSound: state.pictureSound,
        weeklySound: state.weeklySound,
        approvalSound: state.approvalSound,
        errorSound: state.errorSound,
        isPrivacyMode: state.isPrivacyMode
      })
    }
  },
  actions: {
  },
  namespaced: true
})

export default Home
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, Home)
